import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation, ApprovalTypes } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalModalMessageLabelI18n = props => {
  const {
    approvalType,
    currentOperation
  } = props;
  if (approvalType === ApprovalTypes.DEAL && currentOperation === ApprovalOperation.REJECT) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalMessageLabel.DEAL"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.approvalModalMessageLabel.default"
  });
};
export const ApprovalModalMessageLabelHelpI18n = props => {
  const {
    approvalType,
    currentOperation
  } = props;
  if (approvalType === ApprovalTypes.DEAL && currentOperation === ApprovalOperation.REJECT) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalMessageLabelHelp.DEAL"
    });
  }
  return null;
};